<template>
  <section class="split-text">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container container--flex">
      <h1 class="split-text__head">aleksander bordvik has been involved with startups since 2011 and pushing projects ever since</h1>
      <p class="split-text__text">project management through experience, knowledge through school, applied in real life. aleksander can help with his insights into technology, innovation and digital transformation. With a strong emphasis on actions, your project can move forward fast.</p>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'AleksanderCases',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Aleksander/Aleksander.vue